import { observer } from 'mobx-react-lite'
import { MultiStepMobileWizard } from 'components/Wizards/MobileWizards/MultiStepMobileWizard/MultiStepMobileWizard'
import { SubmitStepProps } from 'components/Wizards/MobileWizards/MultiStepMobileWizard/Types'
import { FlowProps, TextValues } from 'components/Wizards/MobileWizards/Types'
import { WizardType } from 'components/Wizards/schemas/Types'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { useMobileWizardCreateDoc } from 'components/Wizards/MobileWizards/hooks/useMobileWizardCreateDoc'

export const SchematizedTextWizard = observer(<T extends WizardType>(props: FlowProps<T>) => {
  const { schema, onClose, initialValues, ...rest } = props
  const {
    meta: { channel, title },
  } = schema

  const { createDoc } = useMobileWizardCreateDoc(channel as ChannelType | GenerationType, {
    navigateToDocOnComplete: true,
    loadingToast: `Generating your ${title}...`,
  })

  const handleSubmitStep = async ({ values, advance, currentStep, totalSteps }: SubmitStepProps<TextValues>) => {
    if (currentStep === totalSteps - 1) {
      const docValues = {
        ...values,
        filename: values.filename || 'Untitled',
        topic: values.topic || 'TOPIC',
        language: values.language || 'en',
        external_links: values.links?.filter((link) => link !== ''),
        selected_images: values.selected_images || [],
      }

      await createDoc(docValues)
      return
    }

    advance()
  }

  return (
    <MultiStepMobileWizard<TextValues>
      schema={schema}
      onClose={onClose}
      onSubmitStep={handleSubmitStep}
      initialValues={initialValues}
      {...rest}
    />
  )
})
